import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { stream } from 'exceljs';
import { BookingInfo } from '../Models/AirPricingSolutionProperties';
import { ANCIHititFareBreakDownProperties, BookingInfoProperties, BookingPassengerInfoProperties, MealAirArabiaProperties, SectorInformationProperties } from '../Models/BookingPassengerTicketIssuanceProperties';
import { CurrencyConversionProperties } from '../Models/CurrencyConversionProperties';
import {  FlightSearchProperties } from '../Models/FlightSearchProperties';
import { PostAncillaryGetProperties } from '../Models/PostModificationProperties';
import { PostTicketingModificationService } from '../Services/PostTicketingModification.service';
import { TicketIssuanceService } from '../Services/ticketIssuance.service';
import { EmiratesEnumsForExchangedDivide } from '../ticket-issuance/EmiratesModificationFunctions';
import { ModifyFlightAirAiternary, AirBlueMDRQ_SeatRequest, AirBlueMDAARQ_SpecialServiceRequest } from '../Models/FlightSearchProperties';
import { NavMenuComponent } from '../nav-menu/nav-menu.component';
import { Bind } from 'primeng/bind';
import { Dialog } from 'primeng/dialog';
import { NgClass, DecimalPipe, DatePipe } from '@angular/common';
@Component({
    selector: 'app-post_-ancillary',
    templateUrl: './post-ancillary.component.html',
    styleUrls: ['./post-ancillary.component.css'],
    imports: [NavMenuComponent, Bind, Dialog, NgClass, DecimalPipe, DatePipe]
})
/** ANCI_HITIT component*/
export class PostAncillaryComponent {
  /** ANCI_HITIT ctor */
  hititloader: boolean = false;
  constructor(private ticketIssuanceService: TicketIssuanceService, private router: Router, private postservice: PostTicketingModificationService) {
  }
  passengerInfolistnew: BookingPassengerInfoProperties[] = [];
  bookingObj = new BookingInfoProperties();
  oldbookingObj = new BookingInfoProperties();
  sectorinfolist: SectorInformationProperties[] = [];
  mainTabOneCheck: boolean = true;
  mainTabCheck1: boolean = true;
  mainTabCheck2: boolean = false;
  mainTabCheck3: boolean = false;
  passengerBackSelectIndex: number = 0;
  sectorBackSelectIndex: number = 0;
  currentpPassengerIndex: number = 0;
  backpassengerIndex: number = 0;
  currentpsIndex: number = 0;
  currency: string = "";
  currencyRate: number = 1;
  finalBaggageFee: number = 0;
  finalseatFee: number = 0;
  passengernext: boolean[] = [false];
  passengernextbag: boolean[] = [false];
  sectornext: boolean[] = [false];
  sectornextbag: boolean[] = [false];
  sectornextshow: boolean[] = [false];
  sectornextshowbag: boolean[] = [false];
  mealAirArabiaList = new MealAirArabiaProperties();
  seatAirBlueList = new MealAirArabiaProperties();
  farebreakdownList: ANCIHititFareBreakDownProperties[] = [];
  changesectorcheckedhitit: any;
  listofpassengerIndex: string[] = [];
  listofpassengerIndexbag: string[] = [];
  errormessageshow: string = "";
  errorshow: boolean = false;
  typeofbooking: number = 0;
  emiratesEnumsForExchangedDivide = new EmiratesEnumsForExchangedDivide();
  postancillaryget = new PostAncillaryGetProperties();
  isAirblueBagSelected: boolean = false;
  isAirblueSeatSelected: boolean = false;
  ngOnInit() {
    this.hititloader = true;
    let bookingobject = new BookingInfoProperties();
    bookingobject = JSON.parse(localStorage.getItem("postanci"));
    this.typeofbooking = Number(localStorage.getItem("typeofbooking"));
    if (bookingobject.currencyRateByDefault > 0) {
      this.currencyRate = bookingobject.currencyRateByDefault;
    } else {
      this.currencyRate = JSON.parse(sessionStorage.getItem("roe"));
    }

    this.bookingObj = JSON.parse(JSON.stringify(bookingobject));
    this.oldbookingObj = JSON.parse(JSON.stringify(bookingobject));
    this.bookingObj.bookingPassengerInfoProperties = [];
    for (let p = 0; p < bookingobject.bookingPassengerInfoProperties.length; p++) {
      if (bookingobject.bookingPassengerInfoProperties[p].passengerType != 3) {
        this.bookingObj.bookingPassengerInfoProperties.push(bookingobject.bookingPassengerInfoProperties[p]);
        this.listofpassengerIndexbag.push("");
        this.listofpassengerIndex.push("");
      }
    }
    this.farebreakdownList = [];
    this.farebreakdown();
    this.sectornext[0] = true;
    if (this.bookingObj.providerCode == "EK") {
      this.postancillaryget = JSON.parse(sessionStorage.getItem("seatandbaganci"));
    }
    else if (this.bookingObj.providerCode == "PA") {
      this.seatAirBlueList = JSON.parse(sessionStorage.getItem("seatandbaganci"));
    }
    else {
      this.mealAirArabiaList = JSON.parse(sessionStorage.getItem("seatandbaganci"));
    }


    this.currency = this.bookingObj.bookingPassengerInfoProperties[0].exchangeCurrency;
    this.sectorinfolist = this.bookingObj.bookingPassengerInfoProperties[0].sectorInformationProperties;

    this.sectornextshow[0] = true;

    this.tabsmainANCI(1);
    if (this.bookingObj.providerCode == "EK") {
      this.processEmirates();
    }
    else if (this.bookingObj.providerCode == "PA") {
      this.processAirBlue(this.seatAirBlueList);
    }
    else {

      this.processingHitit(this.mealAirArabiaList);
    }
    this.totalPriceConv = this.bookingObj.totalAmount;
    this.hititloader = false;
  }
  processEmirates() {
    this.bookingObj.supplierAirPricingSolution = this.postancillaryget.bookingObj.supplierAirPricingSolution;
    this.bookingObj.modifypricingSolution = this.postancillaryget.bookingObj.modifypricingSolution;
    if (this.typeofbooking == this.emiratesEnumsForExchangedDivide.exchanged) {
      let jsonobj = JSON.parse(this.bookingObj.flightlocationInfoDBSave);
      if (jsonobj.modifyflightProp.FlightLocationInfo.length == 1) {
        if (this.bookingObj.bookingPassengerInfoProperties[0].sectorInformationProperties.length == 0) {
          this.stopcount = 0;
        }
        else {
          this.stopcount = 1;
        }
      }
      else if (jsonobj.modifyflightProp.FlightLocationInfo.length == 2 && jsonobj.modifyflightProp.TripType != "multi") {
        if (this.bookingObj.bookingPassengerInfoProperties[0].sectorInformationProperties.length == 2) {
          this.stopcount = 0;
        }
        else {
          this.stopcount = 1;
        }
      }
      else if (jsonobj.modifyflightProp.FlightLocationInfo.length >= 2 && jsonobj.modifyflightProp.TripType == "multi") {
        if (this.bookingObj.bookingPassengerInfoProperties[0].sectorInformationProperties.length == jsonobj.modifyflightProp.FlightLocationInfo.length) {
          this.stopcount = 0;
        }
        else {
          this.stopcount = 1;
        }
      }

      for (let j = 0; j < this.bookingObj.bookingPassengerInfoProperties.length; j++) {
        for (let z = 0; z < this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.length; z++) {
          if (this.postancillaryget.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].seatListBysectorResponsive != null) {
            if (this.postancillaryget.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].seatListBysectorResponsive.dynamicSeatsWithRowsExec != null) {
              this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].seatListBysectorExec = JSON.parse(JSON.stringify(this.postancillaryget.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].seatListBysectorResponsive.dynamicSeatsWithRowsExec.rows));
              this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].seatsectionAirplaneExec = JSON.parse(JSON.stringify(this.postancillaryget.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].seatListBysectorResponsive.dynamicSeatsWithRowsExec.seatSection));

            }
            if (this.postancillaryget.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].seatListBysectorResponsive.dynamicSeatsWithRowsEco != null) {
              this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].seatListBysector = JSON.parse(JSON.stringify(this.postancillaryget.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].seatListBysectorResponsive.dynamicSeatsWithRowsEco.rows));
              this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].seatsectionAirplane = JSON.parse(JSON.stringify(this.postancillaryget.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].seatListBysectorResponsive.dynamicSeatsWithRowsEco.seatSection));

            }
          }
          if (this.postancillaryget.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggaesBysector != null) {
            this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggaesBysector = JSON.parse(JSON.stringify(this.postancillaryget.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggaesBysector));
          }
        }
      }
      for (let j = 0; j < this.bookingObj.bookingPassengerInfoProperties.length; j++) {
        const btnSetMap: Record<number, boolean> = {};
        if (this.bookingObj.bookingPassengerInfoProperties[j].passengerType != 3) {
          this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.forEach(sector => {
            if (!btnSetMap[sector.flightIndex]) {
              sector.baggagebtn = true;
              btnSetMap[sector.flightIndex] = true;
            }
          });
        }
      }
    }
    else {


      if (this.bookingObj.galileoBookingProp.flightProp.flightLocationInfo.length == 1) {
        if (this.bookingObj.bookingPassengerInfoProperties[0].sectorInformationProperties.length == 0) {
          this.stopcount = 0;
        }
        else {
          this.stopcount = 1;
        }
      }
      else if (this.bookingObj.galileoBookingProp.flightProp.flightLocationInfo.length == 2 && this.bookingObj.galileoBookingProp.flightProp.tripType != "multi") {
        if (this.bookingObj.bookingPassengerInfoProperties[0].sectorInformationProperties.length == 2) {
          this.stopcount = 0;
        }
        else {
          this.stopcount = 1;
        }
      }
      else if (this.bookingObj.galileoBookingProp.flightProp.flightLocationInfo.length >= 2 && this.bookingObj.galileoBookingProp.flightProp.tripType == "multi") {
        if (this.bookingObj.bookingPassengerInfoProperties[0].sectorInformationProperties.length == this.bookingObj.galileoBookingProp.flightProp.flightLocationInfo.length) {
          this.stopcount = 0;
        }
        else {
          this.stopcount = 1;
        }
      }

      for (let j = 0; j < this.bookingObj.bookingPassengerInfoProperties.length; j++) {
        for (let z = 0; z < this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.length; z++) {
          if (this.postancillaryget.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].seatListBysectorResponsive != null) {
            if (this.postancillaryget.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].seatListBysectorResponsive.dynamicSeatsWithRowsExec != null) {
              this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].seatListBysectorExec = JSON.parse(JSON.stringify(this.postancillaryget.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].seatListBysectorResponsive.dynamicSeatsWithRowsExec.rows));
              this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].seatsectionAirplaneExec = JSON.parse(JSON.stringify(this.postancillaryget.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].seatListBysectorResponsive.dynamicSeatsWithRowsExec.seatSection));

            }
            if (this.postancillaryget.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].seatListBysectorResponsive.dynamicSeatsWithRowsEco != null) {
              this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].seatListBysector = JSON.parse(JSON.stringify(this.postancillaryget.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].seatListBysectorResponsive.dynamicSeatsWithRowsEco.rows));
              this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].seatsectionAirplane = JSON.parse(JSON.stringify(this.postancillaryget.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].seatListBysectorResponsive.dynamicSeatsWithRowsEco.seatSection));

            }
          }
          if (this.postancillaryget.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggaesBysector != null) {
            this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggaesBysector = JSON.parse(JSON.stringify(this.postancillaryget.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggaesBysector));
          }
        }
      }
      for (let j = 0; j < this.bookingObj.bookingPassengerInfoProperties.length; j++) {
        const btnSetMap: Record<number, boolean> = {};
        if (this.bookingObj.bookingPassengerInfoProperties[j].passengerType != 3) {
          this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.forEach(sector => {
            if (!btnSetMap[sector.flightIndex]) {
              sector.baggagebtn = true;
              btnSetMap[sector.flightIndex] = true;
            }
          });
        }
      }
    }
  }
  farebreakdown() {
    let adulttaxes = 0;
    let adultbase = 0;
    let adultservice = 0;
    let adultnetfrom = 0;
    let childtaxes = 0;
    let childbase = 0;
    let childservice = 0;
    let childnetfrom = 0;
    let infantbase = 0;
    let infanttaxes = 0;
    let infantservice = 0;
    let infantnetfrom = 0;
    let counadult = 0;
    let countchild = 0;
    let countinf = 0;
    let adultSeatFees = 0;
    let childSeatFees = 0;
    let adultBaggageFees = 0;
    let childBaggageFees = 0;

    for (let i = 0; i < this.oldbookingObj.bookingPassengerInfoProperties.length; i++) {
      let passengerSeatFee = 0;
      let passengerBaggageFee = 0;
      if (this.oldbookingObj.bookingPassengerInfoProperties[i].passengerType == 1) {
        //adulttaxes += this.bookingObj.bookingPassengerInfoProperties[i].totalTaxes;
        //adultbase += this.bookingObj.bookingPassengerInfoProperties[i].baseFare;
        //adultservice += this.bookingObj.bookingPassengerInfoProperties[i].serviceCharges;

        for (let j = 0; j < this.oldbookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties.length; j++) {
          passengerSeatFee += (this.oldbookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[j].seatFee * this.oldbookingObj.passengerFares[0].currencyRate);
          passengerBaggageFee += (this.oldbookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[j].baggageFee * this.oldbookingObj.passengerFares[0].currencyRate);
        }
        // Updated the net from supplier and other fare things in new booking object and also in old booking object so that we can add new seat
        this.oldbookingObj.bookingPassengerInfoProperties[i].netFromCustomer -= passengerSeatFee;
        this.bookingObj.bookingPassengerInfoProperties[i].netFromCustomer -= passengerSeatFee;
        this.oldbookingObj.bookingPassengerInfoProperties[i].costFromAmount -= passengerSeatFee;
        this.bookingObj.bookingPassengerInfoProperties[i].costFromAmount -= passengerSeatFee;
        this.oldbookingObj.bookingPassengerInfoProperties[i].costFromCurrency -= passengerSeatFee;
        this.bookingObj.bookingPassengerInfoProperties[i].costFromCurrency -= passengerSeatFee;
        // Updated the net from supplier and other fare things in new booking object and also in old booking object so that we can add new Baggage
        this.oldbookingObj.bookingPassengerInfoProperties[i].netFromCustomer -= passengerBaggageFee;
        this.bookingObj.bookingPassengerInfoProperties[i].netFromCustomer -= passengerBaggageFee;
        this.oldbookingObj.bookingPassengerInfoProperties[i].costFromAmount -= passengerBaggageFee;
        this.bookingObj.bookingPassengerInfoProperties[i].costFromAmount -= passengerBaggageFee;
        this.oldbookingObj.bookingPassengerInfoProperties[i].costFromCurrency -= passengerBaggageFee;
        this.bookingObj.bookingPassengerInfoProperties[i].costFromCurrency -= passengerBaggageFee;
        if (passengerSeatFee > 0) {
          this.oldbookingObj.bookingPassengerInfoProperties[i].netToSupplier -= (passengerSeatFee / this.oldbookingObj.passengerFares[0].currencyRate);
          this.bookingObj.bookingPassengerInfoProperties[i].netToSupplier -= (passengerSeatFee / this.oldbookingObj.passengerFares[0].currencyRate);
        }
        if (passengerBaggageFee > 0) {
          this.oldbookingObj.bookingPassengerInfoProperties[i].netToSupplier -= (passengerBaggageFee / this.oldbookingObj.passengerFares[0].currencyRate);
          this.bookingObj.bookingPassengerInfoProperties[i].netToSupplier -= (passengerBaggageFee / this.oldbookingObj.passengerFares[0].currencyRate);
        }

        adultnetfrom += this.oldbookingObj.bookingPassengerInfoProperties[i].netFromCustomer;
        adultSeatFees += passengerSeatFee;
        adultBaggageFees += passengerBaggageFee;
        counadult++;
      }
      else if (this.oldbookingObj.bookingPassengerInfoProperties[i].passengerType == 2) {
        //childtaxes += this.bookingObj.bookingPassengerInfoProperties[i].totalTaxes;
        //childbase += this.bookingObj.bookingPassengerInfoProperties[i].baseFare;
        //childservice += this.bookingObj.bookingPassengerInfoProperties[i].serviceCharges;
        for (let j = 0; j < this.oldbookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties.length; j++) {
          passengerSeatFee += (this.oldbookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[j].seatFee * this.oldbookingObj.passengerFares[0].currencyRate);
          passengerBaggageFee += (this.oldbookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[j].baggageFee * this.oldbookingObj.passengerFares[0].currencyRate);
        }
        // Updated the net from supplier and other fare things in new booking object and also in old booking object so that we can add new seat
        this.oldbookingObj.bookingPassengerInfoProperties[i].netFromCustomer -= passengerSeatFee;
        this.bookingObj.bookingPassengerInfoProperties[i].netFromCustomer -= passengerSeatFee;
        this.oldbookingObj.bookingPassengerInfoProperties[i].costFromAmount -= passengerSeatFee;
        this.bookingObj.bookingPassengerInfoProperties[i].costFromAmount -= passengerSeatFee;
        this.oldbookingObj.bookingPassengerInfoProperties[i].costFromCurrency -= passengerSeatFee;
        this.bookingObj.bookingPassengerInfoProperties[i].costFromCurrency -= passengerSeatFee;
        // Updated the net from supplier and other fare things in new booking object and also in old booking object so that we can add new Baggage
        this.oldbookingObj.bookingPassengerInfoProperties[i].netFromCustomer -= passengerBaggageFee;
        this.bookingObj.bookingPassengerInfoProperties[i].netFromCustomer -= passengerBaggageFee;
        this.oldbookingObj.bookingPassengerInfoProperties[i].costFromAmount -= passengerBaggageFee;
        this.bookingObj.bookingPassengerInfoProperties[i].costFromAmount -= passengerBaggageFee;
        this.oldbookingObj.bookingPassengerInfoProperties[i].costFromCurrency -= passengerBaggageFee;
        this.bookingObj.bookingPassengerInfoProperties[i].costFromCurrency -= passengerBaggageFee;
        if (passengerSeatFee > 0) {
          this.oldbookingObj.bookingPassengerInfoProperties[i].netToSupplier -= (passengerSeatFee / this.oldbookingObj.passengerFares[0].currencyRate);
          this.bookingObj.bookingPassengerInfoProperties[i].netToSupplier -= (passengerSeatFee / this.oldbookingObj.passengerFares[0].currencyRate);
        }
        if (passengerBaggageFee > 0) {
          this.oldbookingObj.bookingPassengerInfoProperties[i].netToSupplier -= (passengerBaggageFee / this.oldbookingObj.passengerFares[0].currencyRate);
          this.bookingObj.bookingPassengerInfoProperties[i].netToSupplier -= (passengerBaggageFee / this.oldbookingObj.passengerFares[0].currencyRate);
        }
        childnetfrom += this.oldbookingObj.bookingPassengerInfoProperties[i].netFromCustomer;
        childSeatFees += passengerSeatFee;
        childBaggageFees += passengerBaggageFee;
        countchild++;
      }
      else if (this.oldbookingObj.bookingPassengerInfoProperties[i].passengerType == 3) {
        //infantbase += this.bookingObj.bookingPassengerInfoProperties[i].totalTaxes;
        //infanttaxes += this.bookingObj.bookingPassengerInfoProperties[i].baseFare;
        //infantservice += this.bookingObj.bookingPassengerInfoProperties[i].serviceCharges;
        infantnetfrom += this.oldbookingObj.bookingPassengerInfoProperties[i].netFromCustomer;
        countinf++;
      }

    }

    if (counadult > 0) {
      let newpfs = new ANCIHititFareBreakDownProperties();
      newpfs.totalAmount = adultnetfrom;
      newpfs.pstype = "Adult";
      newpfs.pscount = counadult;
      newpfs.seatFee = adultSeatFees;
      newpfs.baggageFee = adultBaggageFees;
      this.farebreakdownList.push(newpfs);
    }
    if (countchild > 0) {
      let newpfs = new ANCIHititFareBreakDownProperties();
      //newpfs.BaseFare = childbase;
      //newpfs.TotalTaxes = childtaxes;
      //newpfs.ServiceCharges = childservice;
      newpfs.totalAmount = childnetfrom;
      newpfs.pscount = countchild;
      newpfs.pstype = "Child";
      newpfs.seatFee = childSeatFees;
      newpfs.baggageFee = childBaggageFees;
      this.farebreakdownList.push(newpfs);
    }
    if (countinf > 0) {
      let newpfs = new ANCIHititFareBreakDownProperties();
      //newpfs.BaseFare = infantbase;
      //newpfs.TotalTaxes = infanttaxes;
      //newpfs.ServiceCharges = infantservice;
      newpfs.totalAmount = infantnetfrom;
      newpfs.pstype = "Infant";
      newpfs.pscount = countinf;
      this.farebreakdownList.push(newpfs);
    }
  }
  stopcount: number = 0;
  processingHitit(meal) {
    try {
      //this.bookingObj.galileoBookingProp.flightProp.flightLocationInfo[0].fromAirport
      if (this.bookingObj.galileoBookingProp.flightProp.flightLocationInfo.length == 1) {
        if (this.bookingObj.bookingPassengerInfoProperties[0].sectorInformationProperties.length == 0) {
          this.stopcount = 0;
        }
        else {
          this.stopcount = 1;
        }
      }
      else if (this.bookingObj.galileoBookingProp.flightProp.flightLocationInfo.length == 2 && this.bookingObj.galileoBookingProp.flightProp.tripType != "multi") {
        if (this.bookingObj.bookingPassengerInfoProperties[0].sectorInformationProperties.length == 2) {
          this.stopcount = 0;
        }
        else {
          this.stopcount = 1;
        }
      }
      else if (this.bookingObj.galileoBookingProp.flightProp.flightLocationInfo.length >= 2 && this.bookingObj.galileoBookingProp.flightProp.tripType == "multi") {
        if (this.bookingObj.bookingPassengerInfoProperties[0].sectorInformationProperties.length == this.bookingObj.galileoBookingProp.flightProp.flightLocationInfo.length) {
          this.stopcount = 0;
        }
        else {
          this.stopcount = 1;
        }
      }

      this.mealAirArabiaList = meal;

      for (let j = 0; j < this.bookingObj.bookingPassengerInfoProperties.length; j++) {
        if (this.bookingObj.bookingPassengerInfoProperties[j].passengerType != 3) {

          //brand check condition basic or other


          for (let z = 0; z < this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.length; z++) {
            this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggagebtn = false;
            if (meal.seatbysector != null) {
              for (let y = 0; y < this.mealAirArabiaList.seatbysector.length; y++) {
                if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport == this.mealAirArabiaList.seatbysector[y].fromCity
                  && this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport == this.mealAirArabiaList.seatbysector[y].toCity) {
                  if (this.mealAirArabiaList.seatbysector[y].dynamicSeatsWithRowsExec != null) {
                    this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].seatListBysectorExec = JSON.parse(JSON.stringify(this.mealAirArabiaList.seatbysector[y].dynamicSeatsWithRowsExec.rows));
                    this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].seatsectionAirplaneExec = JSON.parse(JSON.stringify(this.mealAirArabiaList.seatbysector[y].dynamicSeatsWithRowsExec.seatSection));

                  }
                  if (this.mealAirArabiaList.seatbysector[y].dynamicSeatsWithRowsEco != null) {
                    this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].seatListBysector = JSON.parse(JSON.stringify(this.mealAirArabiaList.seatbysector[y].dynamicSeatsWithRowsEco.rows));
                  }
                  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].seatsectionAirplane = JSON.parse(JSON.stringify(this.mealAirArabiaList.seatbysector[y].dynamicSeatsWithRowsEco.seatSection));
                  break;
                }
              }
            }
          }
          /*/oneway/*/
          if (this.bookingObj.galileoBookingProp.flightProp.flightLocationInfo.length == 1 && this.bookingObj.galileoBookingProp.flightProp.tripType != "multi") {
            this.onewayBaggage(j);
          }
          else if (this.bookingObj.galileoBookingProp.flightProp.flightLocationInfo.length == 2 && this.bookingObj.galileoBookingProp.flightProp.tripType != "multi") {
            /* return flight*/
            this.roundTripBaggage(j);
          }
          else if (this.bookingObj.galileoBookingProp.flightProp.flightLocationInfo.length >= 2 && this.bookingObj.galileoBookingProp.flightProp.tripType == "multi") {
            this.multiCityBaggage(j);
          }

        }
      }

    }
    catch (ee) {
      console.log(ee);
    }
    console.log(this.bookingObj);
    this.hititloader = false;

  }
  onewayBaggage(j) {
    for (let c = 0; c < this.bookingObj.galileoBookingProp.flightProp.flightLocationInfo.length; c++) {
      for (let q = 0; q < this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.length; q++) {

        if (c == this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].flightIndex) {
          for (let v = 0; v < this.mealAirArabiaList.sectorbaggage.length; v++) {
            this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].ssrObj = this.mealAirArabiaList.sectorbaggage[v].ssrObj;
            if (this.mealAirArabiaList.sectorbaggage[v].baggages != null && this.mealAirArabiaList.sectorbaggage[v].baggages.length > 0) {
              if (this.mealAirArabiaList.sectorbaggage[v].baggages[0].baggageCharge != null && this.mealAirArabiaList.sectorbaggage[v].baggages[0].baggageCharge != 0) {
                this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].baggagebtn = false;
                this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].baggaesBysector = this.mealAirArabiaList.sectorbaggage[v].baggages;
                //if (q == 0) {
                //  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].baggagebtn = true;
                //}
                //else if (q == this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.length - 1) {
                //  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].baggagebtn = false;
                //}
                this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].baggagebtn = this.mealAirArabiaList.sectorbaggage[v].sectorinfolist[q].baggageavailiable;
                break;
              }
            }
          }



        }
      }
    }






    //if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.length > 1) {
    //  if (this.stopcount >= 1) {
    //    for (let c = 0; c < this.bookingObj.galileoBookingProp.flightProp.flightLocationInfo.length; c++) {
    //      for (let q = 0; q < this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.length; q++) {

    //        if (this.bookingObj.galileoBookingProp.flightProp.flightLocationInfo[c].fromCity.trim() == this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].fromAirport
    //          && this.bookingObj.galileoBookingProp.flightProp.flightLocationInfo[c].toCity.trim() != this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].toAirport) {
    //          for (let v = 0; v < this.mealAirArabiaList.sectorbaggage.length; v++) {
    //            for (let u = 0; u < this.mealAirArabiaList.sectorbaggage[v].sectorinfolist.length; u++) {
    //              if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].fromAirport == this.mealAirArabiaList.sectorbaggage[v].sectorinfolist[u].fromCity
    //                && this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].toAirport == this.mealAirArabiaList.sectorbaggage[v].sectorinfolist[u].toCity) {
    //                this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].baggaesBysector = this.mealAirArabiaList.sectorbaggage[v].baggages;
    //                this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].baggagebtn = true;
    //              }
    //            }

    //          }


    //        }
    //        else if (this.bookingObj.galileoBookingProp.flightProp.flightLocationInfo[c].fromCity.trim() != this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].fromAirport
    //          && this.bookingObj.galileoBookingProp.flightProp.flightLocationInfo[c].toCity.trim() == this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].toAirport) {
    //          for (let v = 0; v < this.mealAirArabiaList.sectorbaggage.length; v++) {
    //            for (let u = 0; u < this.mealAirArabiaList.sectorbaggage[v].sectorinfolist.length; u++) {
    //              if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].fromAirport == this.mealAirArabiaList.sectorbaggage[v].sectorinfolist[u].fromCity
    //                && this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].toAirport == this.mealAirArabiaList.sectorbaggage[v].sectorinfolist[u].toCity) {
    //                this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].baggaesBysector = this.mealAirArabiaList.sectorbaggage[v].baggages;
    //                this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].baggagebtn = false;
    //              }
    //            }

    //          }
    //        }
    //      }
    //    }
    //  }
    //}
    //else {
    //  for (let c = 0; c < this.bookingObj.galileoBookingProp.flightProp.flightLocationInfo.length; c++) {
    //    for (let q = 0; q < this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.length; q++) {

    //      //for baggages
    //      if (this.bookingObj.galileoBookingProp.flightProp.flightLocationInfo[c].fromCity.trim() == this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].fromAirport
    //        && this.bookingObj.galileoBookingProp.flightProp.flightLocationInfo[c].toCity.trim() == this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].toAirport) {
    //        if (this.mealAirArabiaList.sectorbaggage != null) {
    //          this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].baggaesBysector = this.mealAirArabiaList.sectorbaggage[c].baggages;
    //          this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].baggagebtn = true;
    //        }


    //      }

    //    }
    //  }


    //}
  }
  processAirblueonewayBaggage(j) {
    try {
      for (let c = 0; c < this.bookingObj.galileoBookingProp.flightProp.flightLocationInfo.length; c++) {
        for (let q = 0; q < this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.length; q++) {

          if (c == this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].flightIndex) {
            for (let v = 0; v < this.seatAirBlueList.sectorbaggage.length; v++) {
              this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].ssrObj = this.seatAirBlueList.sectorbaggage[v].ssrObj;
              if (this.seatAirBlueList.sectorbaggage[v].baggages != null && this.seatAirBlueList.sectorbaggage[v].baggages.length > 0) {
                if (this.seatAirBlueList.sectorbaggage[v].baggages[0].baggageCharge != null && this.seatAirBlueList.sectorbaggage[v].baggages[0].baggageCharge != 0) {
                  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].baggagebtn = false;
                  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].baggaesBysector = this.seatAirBlueList.sectorbaggage[v].baggages;
                  //if (q == 0) {
                  //  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].baggagebtn = true;
                  //}
                  //else if (q == this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.length - 1) {
                  //  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].baggagebtn = false;
                  //}
                  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].baggagebtn = this.seatAirBlueList.sectorbaggage[v].sectorinfolist[q].baggageavailiable;
                  break;
                }
              }
            }



          }
        }
      }

    }
    catch (ee) {
      console.log(ee);
    }




    //if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.length > 1) {
    //  if (this.stopcount >= 1) {
    //    for (let c = 0; c < this.bookingObj.galileoBookingProp.flightProp.flightLocationInfo.length; c++) {
    //      for (let q = 0; q < this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.length; q++) {

    //        if (this.bookingObj.galileoBookingProp.flightProp.flightLocationInfo[c].fromCity.trim() == this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].fromAirport
    //          && this.bookingObj.galileoBookingProp.flightProp.flightLocationInfo[c].toCity.trim() != this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].toAirport) {
    //          for (let v = 0; v < this.mealAirArabiaList.sectorbaggage.length; v++) {
    //            for (let u = 0; u < this.mealAirArabiaList.sectorbaggage[v].sectorinfolist.length; u++) {
    //              if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].fromAirport == this.mealAirArabiaList.sectorbaggage[v].sectorinfolist[u].fromCity
    //                && this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].toAirport == this.mealAirArabiaList.sectorbaggage[v].sectorinfolist[u].toCity) {
    //                this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].baggaesBysector = this.mealAirArabiaList.sectorbaggage[v].baggages;
    //                this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].baggagebtn = true;
    //              }
    //            }

    //          }


    //        }
    //        else if (this.bookingObj.galileoBookingProp.flightProp.flightLocationInfo[c].fromCity.trim() != this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].fromAirport
    //          && this.bookingObj.galileoBookingProp.flightProp.flightLocationInfo[c].toCity.trim() == this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].toAirport) {
    //          for (let v = 0; v < this.mealAirArabiaList.sectorbaggage.length; v++) {
    //            for (let u = 0; u < this.mealAirArabiaList.sectorbaggage[v].sectorinfolist.length; u++) {
    //              if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].fromAirport == this.mealAirArabiaList.sectorbaggage[v].sectorinfolist[u].fromCity
    //                && this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].toAirport == this.mealAirArabiaList.sectorbaggage[v].sectorinfolist[u].toCity) {
    //                this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].baggaesBysector = this.mealAirArabiaList.sectorbaggage[v].baggages;
    //                this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].baggagebtn = false;
    //              }
    //            }

    //          }
    //        }
    //      }
    //    }
    //  }
    //}
    //else {
    //  for (let c = 0; c < this.bookingObj.galileoBookingProp.flightProp.flightLocationInfo.length; c++) {
    //    for (let q = 0; q < this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.length; q++) {

    //      //for baggages
    //      if (this.bookingObj.galileoBookingProp.flightProp.flightLocationInfo[c].fromCity.trim() == this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].fromAirport
    //        && this.bookingObj.galileoBookingProp.flightProp.flightLocationInfo[c].toCity.trim() == this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].toAirport) {
    //        if (this.mealAirArabiaList.sectorbaggage != null) {
    //          this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].baggaesBysector = this.mealAirArabiaList.sectorbaggage[c].baggages;
    //          this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].baggagebtn = true;
    //        }


    //      }

    //    }
    //  }


    //}
  }
  roundTripBaggage(j) {
    for (let c = 0; c < this.bookingObj.galileoBookingProp.flightProp.flightLocationInfo.length; c++) {
      for (let q = 0; q < this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.length; q++) {
        if (c == this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].flightIndex) {
          for (let v = 0; v < this.mealAirArabiaList.sectorbaggage.length; v++) {

            for (let u = 0; u < this.mealAirArabiaList.sectorbaggage[v].sectorinfolist.length; u++) {
              if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].fromAirport == this.mealAirArabiaList.sectorbaggage[v].sectorinfolist[u].fromCity
                && this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].toAirport == this.mealAirArabiaList.sectorbaggage[v].sectorinfolist[u].toCity) {
                this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].ssrObj = this.mealAirArabiaList.sectorbaggage[v].ssrObj;
                if (this.mealAirArabiaList.sectorbaggage[v].baggages != null && this.mealAirArabiaList.sectorbaggage[v].baggages.length > 0) {
                  if (this.mealAirArabiaList.sectorbaggage[v].baggages[0].baggageCharge != null && this.mealAirArabiaList.sectorbaggage[v].baggages[0].baggageCharge != 0) {
                    this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].baggaesBysector = this.mealAirArabiaList.sectorbaggage[v].baggages;
                    //if (q == 0) {
                    //  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].baggagebtn = true;
                    //}
                    //else if (q == this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.length - 1) {
                    //  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].baggagebtn = true;
                    //}
                    this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].baggagebtn = this.mealAirArabiaList.sectorbaggage[v].sectorinfolist[q].baggageavailiable;
                    break;
                  }
                }
              }
            }
          }



        }
      }
    }
  }
  multiCityBaggage(j) {
    for (let c = 0; c < this.bookingObj.galileoBookingProp.flightProp.flightLocationInfo.length; c++) {
      for (let q = 0; q < this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.length; q++) {
        if (c == this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].flightIndex) {

          for (let v = 0; v < this.mealAirArabiaList.sectorbaggage.length; v++) {
            for (let u = 0; u < this.mealAirArabiaList.sectorbaggage[v].sectorinfolist.length; u++) {
              if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].fromAirport == this.mealAirArabiaList.sectorbaggage[v].sectorinfolist[u].fromCity
                && this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].toAirport == this.mealAirArabiaList.sectorbaggage[v].sectorinfolist[u].toCity) {
                this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].ssrObj = this.mealAirArabiaList.sectorbaggage[v].ssrObj;
                if (this.mealAirArabiaList.sectorbaggage[v].baggages != null && this.mealAirArabiaList.sectorbaggage[v].baggages.length > 0) {
                  if (this.mealAirArabiaList.sectorbaggage[v].baggages[0].baggageCharge != null && this.mealAirArabiaList.sectorbaggage[v].baggages[0].baggageCharge != 0) {
                    this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].baggaesBysector = this.mealAirArabiaList.sectorbaggage[v].baggages;
                    this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].baggagebtn = this.mealAirArabiaList.sectorbaggage[v].sectorinfolist[q].baggageavailiable;
                    break;
                  }
                }
              }
            }
          }
        }
      }
    }

  }
  processAirblueroundTripBaggage(j) {
    try {
      for (let c = 0; c < this.bookingObj.galileoBookingProp.flightProp.flightLocationInfo.length; c++) {
        for (let q = 0; q < this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.length; q++) {
          if (c == this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].flightIndex) {
            for (let v = 0; v < this.seatAirBlueList.sectorbaggage.length; v++) {

              for (let u = 0; u < this.seatAirBlueList.sectorbaggage[v].sectorinfolist.length; u++) {
                if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].fromAirport == this.seatAirBlueList.sectorbaggage[v].sectorinfolist[u].fromCity
                  && this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].toAirport == this.seatAirBlueList.sectorbaggage[v].sectorinfolist[u].toCity) {
                  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].ssrObj = this.seatAirBlueList.sectorbaggage[v].ssrObj;
                  if (this.seatAirBlueList.sectorbaggage[v].baggages != null && this.seatAirBlueList.sectorbaggage[v].baggages.length > 0) {
                    if (this.seatAirBlueList.sectorbaggage[v].baggages[0].baggageCharge != null && this.seatAirBlueList.sectorbaggage[v].baggages[0].baggageCharge != 0) {
                      this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].baggaesBysector = this.seatAirBlueList.sectorbaggage[v].baggages;
                      //if (q == 0) {
                      //  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].baggagebtn = true;
                      //}
                      //else if (q == this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.length - 1) {
                      //  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].baggagebtn = true;
                      //}
                      this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].baggagebtn = this.seatAirBlueList.sectorbaggage[v].sectorinfolist[0].baggageavailiable;
                      break;
                    }
                  }
                }
              }
            }



          }
        }
      }
    }
    catch (ee) {
      console.log(ee);
    }
    //if (this.bookingObj.galileoBookingProp.flightProp.flightLocationInfo.length == 2 && this.bookingObj.galileoBookingProp.flightProp.tripType != "multi") {
    //  /*   return single flight*/
    //  if (this.stopcount == 0) {
    //    for (let c = 0; c < this.bookingObj.galileoBookingProp.flightProp.flightLocationInfo.length; c++) {
    //      for (let q = 0; q < this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.length; q++) {

    //        if (this.bookingObj.galileoBookingProp.flightProp.flightLocationInfo[c].fromCity.trim() == this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].fromAirport
    //          && this.bookingObj.galileoBookingProp.flightProp.flightLocationInfo[c].toCity.trim() == this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].toAirport) {
    //          for (let v = 0; v < this.seatAirBlueList.sectorbaggage.length; v++) {
    //            for (let u = 0; u < this.seatAirBlueList.sectorbaggage[v].sectorinfolist.length; u++) {
    //              if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].fromAirport == this.seatAirBlueList.sectorbaggage[v].sectorinfolist[u].fromCity
    //                && this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].toAirport == this.seatAirBlueList.sectorbaggage[v].sectorinfolist[u].toCity) {
    //                this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].baggaesBysector = this.seatAirBlueList.sectorbaggage[v].baggages;
    //                this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].baggagebtn = true;
    //                break;
    //              }
    //            }

    //          }

    //        }

    //      }
    //    }
    //  }
    //  /*   return connect flight*/
    //  else if (this.stopcount >= 1) {
    //    for (let c = 0; c < this.bookingObj.galileoBookingProp.flightProp.flightLocationInfo.length; c++) {
    //      for (let q = 0; q < this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.length; q++) {
    //        if (0 == this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].flightIndex) {
    //          for (let v = 0; v < this.seatAirBlueList.sectorbaggage.length; v++) {
    //            if (this.seatAirBlueList.sectorbaggage[v].baggages != null) {
    //              if (this.seatAirBlueList.sectorbaggage[v].baggages[0].baggageCharge != null && this.seatAirBlueList.sectorbaggage[v].baggages[0].baggageCharge != 0) {

    //                  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].baggaesBysector = this.seatAirBlueList.sectorbaggage[v].baggages;
    //                  if (q == 0) {
    //                    this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].baggagebtn = true;
    //                  }
    //                  break;
    //                }
    //              }
    //            }



    //        }
    //        else if (1 == this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].flightIndex) {
    //          for (let v = 0; v < this.seatAirBlueList.sectorbaggage.length; v++) {

    //              if (this.seatAirBlueList.sectorbaggage[v].baggages != null) {
    //                if (this.seatAirBlueList.sectorbaggage[v].baggages[0].baggageCharge != null && this.seatAirBlueList.sectorbaggage[v].baggages[0].baggageCharge != 0) {
    //                  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].baggaesBysector = this.seatAirBlueList.sectorbaggage[v].baggages;
    //                  if (q==this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.length - 1) {
    //                    this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].baggagebtn = true;
    //                  }
    //                    break;
    //                }
    //              }

    //          }

    //        }
    //      }
    //    }
    //  }
    //}

  }
  processAirbluemultiCityBaggage(j) {
    try {
      for (let c = 0; c < this.bookingObj.galileoBookingProp.flightProp.flightLocationInfo.length; c++) {
        for (let q = 0; q < this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.length; q++) {
          if (c == this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].flightIndex) {

            for (let v = 0; v < this.seatAirBlueList.sectorbaggage.length; v++) {
              for (let u = 0; u < this.seatAirBlueList.sectorbaggage[v].sectorinfolist.length; u++) {
                if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].fromAirport == this.seatAirBlueList.sectorbaggage[v].sectorinfolist[u].fromCity
                  && this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].toAirport == this.seatAirBlueList.sectorbaggage[v].sectorinfolist[u].toCity) {
                  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].ssrObj = this.seatAirBlueList.sectorbaggage[v].ssrObj;
                  if (this.seatAirBlueList.sectorbaggage[v].baggages != null && this.seatAirBlueList.sectorbaggage[v].baggages.length > 0) {
                    if (this.seatAirBlueList.sectorbaggage[v].baggages[0].baggageCharge != null && this.seatAirBlueList.sectorbaggage[v].baggages[0].baggageCharge != 0) {
                      this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].baggaesBysector = this.seatAirBlueList.sectorbaggage[v].baggages;
                      this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].baggagebtn = this.seatAirBlueList.sectorbaggage[v].sectorinfolist[q].baggageavailiable;
                      break;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    catch (ee) {
      console.log(ee);
    }
  }
  sectorselectionBag(i, y) {


    try {
      this.sectornextbag[this.sectorBackSelectIndex] = false;
      this.sectornextshowbag[this.sectorBackSelectIndex] = false;
    }
    catch (e) { }
    this.sectornextbag[y] = true;
    this.sectornextshowbag[y] = true;


    this.sectorBackSelectIndex = y;
    this.backpassengerIndex = i;
  }
  sectorselection(i, y) {



    try {
      this.sectornext[this.sectorBackSelectIndex] = false;
      this.sectornextshow[this.sectorBackSelectIndex] = false;
      /*  document.getElementById(`sectorselect${this.sectorBackSelectIndex}`).classList.remove("backcolorofjs");*/
      /*  document.getElementById(`newmodelofseat${this.backpassengerIndex}${this.sectorBackSelectIndex}`).classList.add("displayblock");*/
    }
    catch (e) { }
    this.sectornext[y] = true;
    this.sectornextshow[y] = true;
    //document.getElementById(`sectorselect${y}`).classList.add("backcolorofjs");
    //document.getElementById(`newmodelofseat${i}${y}`).classList.remove("displayblock");


    this.sectorBackSelectIndex = y;
    this.backpassengerIndex = i;
  }
  passengerselection(i) {


    try {
      this.passengernext[this.passengerBackSelectIndex] = false;
    }
    catch (e) { }
    this.sectornext = [];
    this.sectornextshow = [];
    this.sectornext[0] = true;
    this.sectornextshow[0] = true;
    this.passengernext[i + 1] = true;

    this.passengerBackSelectIndex = i + 1;
    this.sectorBackSelectIndex = 0;


  }
  passengerselectionbag(i) {

    try {
      this.passengernextbag[this.passengerBackSelectIndex] = false;
    }
    catch (e) { }
    this.sectornextbag = [];
    this.sectornextshowbag = [];
    this.sectornextbag[0] = true;
    this.sectornextshowbag[0] = true;
    this.passengernextbag[i + 1] = true;
    this.sectorBackSelectIndex = 0;
    this.passengerBackSelectIndex = i + 1;


  }
  passengerBACK(i) {

    if (i != 0) {
      try {
        this.passengernext[this.passengerBackSelectIndex] = false;
      }
      catch (e) { }
      this.sectornext = [];
      this.sectornextshow = [];
      this.sectornext[0] = true;

      this.sectornextshow[0] = true;
      this.passengernext[i - 1] = true;

      this.passengerBackSelectIndex = i - 1;
      this.sectorBackSelectIndex = 0;
    }
  }
  passengerBACKbag(i) {

    if (i != 0) {
      try {
        this.passengernextbag[this.passengerBackSelectIndex] = false;
      }
      catch (e) { }
      this.sectornextbag = [];
      this.sectornextshowbag = [];
      this.sectornextbag[0] = true;
      this.sectornextshowbag[0] = true;
      this.passengernextbag[i - 1] = true;
      this.sectorBackSelectIndex = 0;
      this.passengerBackSelectIndex = i - 1;
    }
  }
  SkipSelection(value) {
    if (value == 3) {
      this.ngOnInit();
      this.tabsmainANCI(value);
    }
    else {
      this.router.navigate([("/ticket-issuance")])
    }
  }
  tabsmainANCI(value) {
    this.backpassengerIndex = 0; this.sectorBackSelectIndex = 0;
    this.passengerBackSelectIndex = 0;
    if (value == 1) {

      document.getElementById(`mainclasstabs${value}`).classList.add("active");
      this.mainTabOneCheck = true;
      this.mainTabCheck1 = true;
      this.mainTabCheck2 = false;
      this.mainTabCheck3 = false;

      /// document.getElementById(`mainclasstabs${2}`).classList.remove("active");
      document.getElementById(`mainclasstabs${3}`).classList.remove("active");
      this.sectornext = [false];
      this.sectornextshow = [false];
      this.passengernext = [false];
      this.sectorselection(0, 0);

      this.passengernext[0] = true;
    }
    else if (value == 2) {
      this.mainTabOneCheck = false;
      this.mainTabCheck1 = false;
      this.mainTabCheck2 = true;
      this.mainTabCheck3 = false;
      document.getElementById(`mainclasstabs${value}`).classList.add("active");
      document.getElementById(`mainclasstabs${1}`).classList.remove("active");
      document.getElementById(`mainclasstabs${3}`).classList.remove("active");
    }
    else if (value == 3) {

      this.mainTabOneCheck = false;
      this.mainTabCheck1 = false;
      this.mainTabCheck2 = false;
      this.mainTabCheck3 = true;
      document.getElementById(`mainclasstabs${value}`).classList.add("active");
      // document.getElementById(`mainclasstabs${2}`).classList.remove("active");
      document.getElementById(`mainclasstabs${1}`).classList.remove("active");
      this.sectornextbag = [false];
      this.sectornextshowbag = [false];
      this.passengernextbag = [false];
      this.sectorselectionBag(0, 0);

      this.passengernextbag[0] = true;

    }

  }
  totalANCIConv: number = 0;
  totalPriceConv: number = 0;
  passngerIndex: number = 0;
  sectorIndex: number = 0;
  seatListIndex: number = 0;
  seatIndex: number = 0;
  seatselectedsector(i, z, k, q, cabin) {



    if (cabin == "Executive") {

      if (this.listofpassengerIndex[i] != "") {
        let list = this.listofpassengerIndex[i].split("-");
        this.passngerIndex = Number(list[0]);
        //console.log(this.passngerIndex, this.seatIndex, this.seatListIndex, this.seatselected);
        this.sectorIndex = Number(list[1]);
        this.seatListIndex = Number(list[2]);

        this.seatIndex = Number(list[3]);

      }
      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].seatNumber
        = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].seatListBysectorExec[k].seats[q].seatCode;
      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].seatFee
        = Number(this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].seatListBysectorExec[k].seats[q].seatCharge);


      try {
        if (i == this.passngerIndex && z == this.sectorIndex) {
          document.getElementById(`link3buttonexec${this.passngerIndex}${this.sectorIndex}${this.seatListIndex}${this.seatIndex}`).classList.remove('classofseats');
          for (let y = 0; y < this.bookingObj.bookingPassengerInfoProperties.length; y++) {
            if (this.bookingObj.bookingPassengerInfoProperties[y].passengerType != 3) {
              if (i != y) {
                this.bookingObj.bookingPassengerInfoProperties[y].sectorInformationProperties[this.sectorIndex].seatListBysectorExec[this.seatListIndex].seats[this.seatIndex].seatStatus = "FR";
              }
            }
          }
        }
      }
      catch (e) {
        console.log(e);
      }
      for (let y = 0; y < this.bookingObj.bookingPassengerInfoProperties.length; y++) {
        if (this.bookingObj.bookingPassengerInfoProperties[y].passengerType != 3) {

          if (i != y) {
            this.bookingObj.bookingPassengerInfoProperties[y].sectorInformationProperties[z].seatListBysectorExec[k].seats[q].seatStatus = "RSP";

          }
        }
      }

      document.getElementById(`link3buttonexec${i}${z}${k}${q}`).classList.add('classofseats');
    }
    else {
      if (this.listofpassengerIndex[i] != "") {
        let list = this.listofpassengerIndex[i].split("-");
        this.passngerIndex = Number(list[0]);
        //console.log(this.passngerIndex, this.seatIndex, this.seatListIndex, this.seatselected);
        this.sectorIndex = Number(list[1]);
        this.seatListIndex = Number(list[2]);

        this.seatIndex = Number(list[3]);
      }

      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].seatNumber
        = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].seatListBysector[k].seats[q].seatCode;
      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].seatkey
        = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].seatListBysector[k].seats[q].seatKey;
      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].seatFee
        = Number(this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].seatListBysector[k].seats[q].seatCharge);


      try {
        if (i == this.passngerIndex && z == this.sectorIndex) {
          document.getElementById(`link3button${this.passngerIndex}${this.sectorIndex}${this.seatListIndex}${this.seatIndex}`).classList.remove('classofseats');

          for (let y = 0; y < this.bookingObj.bookingPassengerInfoProperties.length; y++) {
            if (this.bookingObj.bookingPassengerInfoProperties[y].passengerType != 3) {
              if (i != y) {
                this.bookingObj.bookingPassengerInfoProperties[y].sectorInformationProperties[this.sectorIndex].seatListBysector[this.seatListIndex].seats[this.seatIndex].seatStatus = "FR";

              }
            }


          }
        }


      }
      catch (e) {
        console.log(e);
      }
      for (let y = 0; y < this.bookingObj.bookingPassengerInfoProperties.length; y++) {
        if (this.bookingObj.bookingPassengerInfoProperties[y].passengerType != 3) {

          if (i != y) {
            this.bookingObj.bookingPassengerInfoProperties[y].sectorInformationProperties[z].seatListBysector[k].seats[q].seatStatus = "RSP";

          }
        }
      }


      document.getElementById(`link3button${i}${z}${k}${q}`).classList.add('classofseats');
    }


    this.listofpassengerIndex[i] = i + "-" + z + "-" + k + "-" + q;

    //console.log(this.bookingObj);
    /*    for oneway*/
    let pstype = "";
    if (this.bookingObj.bookingPassengerInfoProperties[i].passengerType == 1) {
      pstype = "Adult";
    }
    else if (this.bookingObj.bookingPassengerInfoProperties[i].passengerType == 2) {
      pstype = "Child";
    }
    if (this.bookingObj.galileoBookingProp.flightProp.flightLocationInfo.length >= 1) {
      /*   check stops*/
      if (this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties.length == 1) {
        let newancifee = 0;
        for (let e = 0; e < this.bookingObj.bookingPassengerInfoProperties.length; e++) {
          if (this.bookingObj.bookingPassengerInfoProperties[e].passengerType == this.bookingObj.bookingPassengerInfoProperties[i].passengerType) {
            for (let d = 0; d < this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties.length; d++) {
              newancifee += Number(this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].seatFee);
            }
          }
        }
        for (let u = 0; u < this.farebreakdownList.length; u++) {
          if (this.farebreakdownList[u].pstype == pstype) {
            this.farebreakdownList[u].seatFee = (newancifee * this.currencyRate);
          }

        }

      }
      else if (this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties.length > 1) {
        let newancifee = 0;
        for (let e = 0; e < this.bookingObj.bookingPassengerInfoProperties.length; e++) {
          if (this.bookingObj.bookingPassengerInfoProperties[e].passengerType == this.bookingObj.bookingPassengerInfoProperties[i].passengerType) {
            for (let d = 0; d < this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties.length; d++) {
              newancifee += Number(this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].seatFee);
            }
          }
        }
        for (let u = 0; u < this.farebreakdownList.length; u++) {
          if (this.farebreakdownList[u].pstype == pstype) {
            this.farebreakdownList[u].seatFee = (newancifee * this.currencyRate);
          }

        }
      }
    }

    for (let r = 0; r < this.farebreakdownList.length; r++) {
      let anciprice = Number(this.farebreakdownList[r].seatFee.toFixed());
      let ancipricebag = Number(this.farebreakdownList[r].baggageFee.toFixed());
      this.farebreakdownList[r].totalamountwithanci = anciprice + ancipricebag;
    }

    /*   for return*/
    let totalamountTtl = 0;
    let ancipriceTtl = 0;
    let ancipricebagTtl = 0;
    for (let o = 0; o < this.farebreakdownList.length; o++) {
      totalamountTtl += Number(this.farebreakdownList[o].totalAmount.toFixed());
      ancipriceTtl += Number(this.farebreakdownList[o].seatFee.toFixed());
      ancipricebagTtl += Number(this.farebreakdownList[o].baggageFee.toFixed());
    }
    this.totalPriceConv = ancipriceTtl + ancipricebagTtl + totalamountTtl;
    this.totalANCIConv = ancipriceTtl + ancipricebagTtl;
    this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].checksectorHitit = true;
    this.bookingObj.selectedBrand2 = 1;
  }
  bagPersonIndex: number = 0;
  baglSectorIndex: number = 0;
  bagListIndex: number = 0;
  removeseat(i, z) {

    if (this.listofpassengerIndex[i] != "") {
      let list = this.listofpassengerIndex[i].split("-");
      this.passngerIndex = Number(list[0]);
      //console.log(this.passngerIndex, this.seatIndex, this.seatListIndex, this.seatselected);
      this.sectorIndex = Number(list[1]);
      this.seatListIndex = Number(list[2]);

      this.seatIndex = Number(list[3]);

    }
    this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].seatNumber
      ="";
    this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].seatFee
      = 0;
    
      try {
        if (i == this.passngerIndex && z == this.sectorIndex) {
          document.getElementById(`link3buttonexec${this.passngerIndex}${this.sectorIndex}${this.seatListIndex}${this.seatIndex}`).classList.remove('classofseats');
          for (let y = 0; y < this.bookingObj.bookingPassengerInfoProperties.length; y++) {
            if (this.bookingObj.bookingPassengerInfoProperties[y].passengerType != 3) {
              if (i != y) {
                this.bookingObj.bookingPassengerInfoProperties[y].sectorInformationProperties[this.sectorIndex].seatListBysectorExec[this.seatListIndex].seats[this.seatIndex].seatStatus = "FR";
              }
            }
          }
        }
      }
      catch (e) {
        console.log(e);
      }
   
      try {
        if (i == this.passngerIndex && z == this.sectorIndex) {
          document.getElementById(`link3button${this.passngerIndex}${this.sectorIndex}${this.seatListIndex}${this.seatIndex}`).classList.remove('classofseats');

          for (let y = 0; y < this.bookingObj.bookingPassengerInfoProperties.length; y++) {
            if (this.bookingObj.bookingPassengerInfoProperties[y].passengerType != 3) {
              if (i != y) {
                this.bookingObj.bookingPassengerInfoProperties[y].sectorInformationProperties[this.sectorIndex].seatListBysector[this.seatListIndex].seats[this.seatIndex].seatStatus = "FR";

              }
            }


          }
        }


      }
      catch (e) {
        console.log(e);
      }
    
   


    let pstype = "";
    if (this.bookingObj.bookingPassengerInfoProperties[i].passengerType == 1) {
      pstype = "Adult";
    }
    else if (this.bookingObj.bookingPassengerInfoProperties[i].passengerType == 2) {
      pstype = "Child";
    }
    if (this.bookingObj.galileoBookingProp.flightProp.flightLocationInfo.length >= 1) {
      /*   check stops*/
      if (this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties.length == 1) {
        let newancifee = 0;
        for (let e = 0; e < this.bookingObj.bookingPassengerInfoProperties.length; e++) {
          if (this.bookingObj.bookingPassengerInfoProperties[e].passengerType == this.bookingObj.bookingPassengerInfoProperties[i].passengerType) {
            for (let d = 0; d < this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties.length; d++) {
              newancifee += Number(this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].seatFee);
            }
          }
        }
        for (let u = 0; u < this.farebreakdownList.length; u++) {
          if (this.farebreakdownList[u].pstype == pstype) {
            this.farebreakdownList[u].seatFee = (newancifee * this.currencyRate);
          }

        }

      }
      else if (this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties.length > 1) {
        let newancifee = 0;
        for (let e = 0; e < this.bookingObj.bookingPassengerInfoProperties.length; e++) {
          if (this.bookingObj.bookingPassengerInfoProperties[e].passengerType == this.bookingObj.bookingPassengerInfoProperties[i].passengerType) {
            for (let d = 0; d < this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties.length; d++) {
              newancifee += Number(this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].seatFee);
            }
          }
        }
        for (let u = 0; u < this.farebreakdownList.length; u++) {
          if (this.farebreakdownList[u].pstype == pstype) {
            this.farebreakdownList[u].seatFee = (newancifee * this.currencyRate);
          }

        }
      }
    }

    for (let r = 0; r < this.farebreakdownList.length; r++) {
      let anciprice = Number(this.farebreakdownList[r].seatFee.toFixed());
      let ancipricebag = Number(this.farebreakdownList[r].baggageFee.toFixed());
      this.farebreakdownList[r].totalamountwithanci = anciprice + ancipricebag;
    }

    /*   for return*/
    let totalamountTtl = 0;
    let ancipriceTtl = 0;
    let ancipricebagTtl = 0;
    for (let o = 0; o < this.farebreakdownList.length; o++) {
      totalamountTtl += Number(this.farebreakdownList[o].totalAmount.toFixed());
      ancipriceTtl += Number(this.farebreakdownList[o].seatFee.toFixed());
      ancipricebagTtl += Number(this.farebreakdownList[o].baggageFee.toFixed());
    }
    this.totalPriceConv = ancipriceTtl + ancipricebagTtl + totalamountTtl;
    this.totalANCIConv = ancipriceTtl + ancipricebagTtl;
    this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].checksectorHitit = false;
  }
  removeBag(i, z) {
    if (this.listofpassengerIndexbag[i] != "") {
      let list = this.listofpassengerIndexbag[i].split("-");
      this.bagPersonIndex = Number(list[0]);
      //console.log(this.passngerIndex, this.seatIndex, this.seatListIndex, this.seatselected);
      this.baglSectorIndex = Number(list[1]);
      this.bagListIndex = Number(list[2]);

    }
    try {
      if (i == this.bagPersonIndex && this.baglSectorIndex == z) {
        document.getElementById(`baggageselectid${this.bagPersonIndex}${this.baglSectorIndex}${this.bagListIndex}`).innerHTML = "Select";
        document.getElementById(`baggageselectbtn${this.bagPersonIndex}${this.baglSectorIndex}${this.bagListIndex}`).style.backgroundColor = "#39454B";
        document.getElementById(`baggageselectbtn${this.bagPersonIndex}${this.baglSectorIndex}${this.bagListIndex}`).style.borderColor = "#39454B";
      }
    }
    catch (e) {
    }
    this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].extraBagCheckIn = "";
    this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].baggagename = "";
    this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].baggageDescription = "";
    this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].baggageFee = 0;
    if (this.bookingObj.galileoBookingProp.flightProp.flightLocationInfo.length >= 1) {
      /*   check stops*/
      let pstype = "";
      if (this.bookingObj.bookingPassengerInfoProperties[i].passengerType == 1) {
        pstype = "Adult";
      }
      else if (this.bookingObj.bookingPassengerInfoProperties[i].passengerType == 2) {
        pstype = "Child";
      }
      if (this.bookingObj.bookingPassengerInfoProperties[0].sectorInformationProperties.length == 1) {
        let newancifee = 0;
        for (let e = 0; e < this.bookingObj.bookingPassengerInfoProperties.length; e++) {
          if (this.bookingObj.bookingPassengerInfoProperties[e].passengerType == this.bookingObj.bookingPassengerInfoProperties[i].passengerType) {
            for (let d = 0; d < this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties.length; d++) {
              newancifee += Number(this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].baggageFee);
            }
          }
        }
        for (let u = 0; u < this.farebreakdownList.length; u++) {
          if (this.farebreakdownList[u].pstype == pstype) {
            this.farebreakdownList[u].baggageFee = newancifee * this.currencyRate;
          }
        }
      }
      else if (this.bookingObj.bookingPassengerInfoProperties[0].sectorInformationProperties.length > 1) {
        let newancifee = 0;
        for (let e = 0; e < this.bookingObj.bookingPassengerInfoProperties.length; e++) {
          if (this.bookingObj.bookingPassengerInfoProperties[e].passengerType == this.bookingObj.bookingPassengerInfoProperties[i].passengerType) {
            for (let d = 0; d < this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties.length; d++) {
              if (this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].baggagebtn == true) {
                newancifee += this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].baggageFee;
              }
            }
          }
        }
        for (let u = 0; u < this.farebreakdownList.length; u++) {
          if (this.farebreakdownList[u].pstype == pstype) {
            this.farebreakdownList[u].baggageFee = newancifee * this.currencyRate;
          }
        }
      }
    }
    for (let r = 0; r < this.farebreakdownList.length; r++) {
      let anciprice = Number(this.farebreakdownList[r].seatFee.toFixed());
      let ancipricebag = Number(this.farebreakdownList[r].baggageFee.toFixed());
      this.farebreakdownList[r].totalamountwithanci = anciprice + ancipricebag;
    }

    /*   for return*/
    let totalamountTtl = 0;
    let ancipriceTtl = 0;
    let ancipricebagTtl = 0;
    for (let o = 0; o < this.farebreakdownList.length; o++) {
      totalamountTtl += Number(this.farebreakdownList[o].totalAmount.toFixed());
      ancipriceTtl += Number(this.farebreakdownList[o].seatFee.toFixed());
      ancipricebagTtl += Number(this.farebreakdownList[o].baggageFee.toFixed());
    }
    this.totalPriceConv = ancipriceTtl + ancipricebagTtl + totalamountTtl;
    this.totalANCIConv = ancipriceTtl + ancipricebagTtl;
  }
  baggageselect(i, z, t) {
    

    if (this.listofpassengerIndexbag[i] != "") {
      let list = this.listofpassengerIndexbag[i].split("-");
      this.bagPersonIndex = Number(list[0]);
      //console.log(this.passngerIndex, this.seatIndex, this.seatListIndex, this.seatselected);
      this.baglSectorIndex = Number(list[1]);
      this.bagListIndex = Number(list[2]);

    }

    let baggagefee = 0;
    let baggagecheck = "";
    let baggagename = "";
    baggagecheck = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].baggaesBysector[t].baggageCode;
    baggagename = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].baggaesBysector[t].baggageDescription;
    baggagefee = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].baggaesBysector[t].baggageCharge;
    this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].extraBagCheckIn =
      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].baggaesBysector[t].baggageCode;
    this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].baggagename =
      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].baggaesBysector[t].baggageDescription;
    this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].baggageDescription =
      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].baggaesBysector[t].baggageDescription;
    this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].baggageFee =
      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].baggaesBysector[t].baggageCharge;
    try {
      if (i == this.bagPersonIndex && this.baglSectorIndex == z) {
        document.getElementById(`baggageselectid${this.bagPersonIndex}${this.baglSectorIndex}${this.bagListIndex}`).innerHTML = "Select";
        document.getElementById(`baggageselectbtn${this.bagPersonIndex}${this.baglSectorIndex}${this.bagListIndex}`).style.backgroundColor = "#39454B";
        document.getElementById(`baggageselectbtn${this.bagPersonIndex}${this.baglSectorIndex}${this.bagListIndex}`).style.borderColor = "#39454B";
      }
    }
    catch (e) {
    }
    try {
      document.getElementById(`baggageselectid${i}${z}${t}`).innerHTML = "Selected";
      document.getElementById(`baggageselectbtn${i}${z}${t}`).style.borderColor = "var(--first-color-second)";
      document.getElementById(`baggageselectbtn${i}${z}${t}`).style.backgroundColor = "var(--first-color-second)";
    }
    catch (e) {
    }
    this.listofpassengerIndexbag[i] = i + "-" + z + "-" + t;
    /*    for oneway*/
    if (this.bookingObj.galileoBookingProp.flightProp.flightLocationInfo.length >= 1) {
      /*   check stops*/
      let pstype = "";
      if (this.bookingObj.bookingPassengerInfoProperties[i].passengerType == 1) {
        pstype = "Adult";
      }
      else if (this.bookingObj.bookingPassengerInfoProperties[i].passengerType == 2) {
        pstype = "Child";
      }
      if (this.bookingObj.bookingPassengerInfoProperties[0].sectorInformationProperties.length == 1) {
        let newancifee = 0;
        for (let e = 0; e < this.bookingObj.bookingPassengerInfoProperties.length; e++) {
          if (this.bookingObj.bookingPassengerInfoProperties[e].passengerType == this.bookingObj.bookingPassengerInfoProperties[i].passengerType) {
            for (let d = 0; d < this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties.length; d++) {
              newancifee += Number(this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].baggageFee);
            }
          }
        }
        for (let u = 0; u < this.farebreakdownList.length; u++) {
          if (this.farebreakdownList[u].pstype == pstype) {
            this.farebreakdownList[u].baggageFee = newancifee * this.currencyRate;
          }
        }
      }
      else if (this.bookingObj.bookingPassengerInfoProperties[0].sectorInformationProperties.length > 1) {
        let newancifee = 0;
        for (let e = 0; e < this.bookingObj.bookingPassengerInfoProperties.length; e++) {
          if (this.bookingObj.bookingPassengerInfoProperties[e].passengerType == this.bookingObj.bookingPassengerInfoProperties[i].passengerType) {
            for (let d = 0; d < this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties.length; d++) {
              if (this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].baggagebtn == true) {
                newancifee += this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].baggageFee;
              }
            }
          }
        }
        for (let u = 0; u < this.farebreakdownList.length; u++) {
          if (this.farebreakdownList[u].pstype == pstype) {
            this.farebreakdownList[u].baggageFee = newancifee * this.currencyRate;
          }
        }
      }
    }
    for (let r = 0; r < this.farebreakdownList.length; r++) {
      let anciprice = Number(this.farebreakdownList[r].seatFee.toFixed());
      let ancipricebag = Number(this.farebreakdownList[r].baggageFee.toFixed());
      this.farebreakdownList[r].totalamountwithanci = anciprice + ancipricebag;
    }

    /*   for return*/
    let totalamountTtl = 0;
    let ancipriceTtl = 0;
    let ancipricebagTtl = 0;
    for (let o = 0; o < this.farebreakdownList.length; o++) {
      totalamountTtl += Number(this.farebreakdownList[o].totalAmount.toFixed());
      ancipriceTtl += Number(this.farebreakdownList[o].seatFee.toFixed());
      ancipricebagTtl += Number(this.farebreakdownList[o].baggageFee.toFixed());
    }
    this.totalPriceConv = ancipriceTtl + ancipricebagTtl + totalamountTtl;
    this.totalANCIConv = ancipriceTtl + ancipricebagTtl;
    if (this.bookingObj.galileoBookingProp.flightProp.flightLocationInfo.length == 1) {
      for (let f = 0; f < this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties.length; f++) {

        this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].extraBagCheckIn = baggagecheck;
        this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageFee = baggagefee;
        this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggagename = baggagename;
        this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageDescription = baggagename;
        this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].checksectorHititbag = true;
      }
    }
    else {
      if (this.stopcount > 0) {
        for (let f = 0; f < this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties.length; f++) {
          if (this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].flightIndex == this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].flightIndex) {
            this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].extraBagCheckIn = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].baggaesBysector[t].baggageCode;
            this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageFee = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].baggaesBysector[t].baggageCharge;
            this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageDescription = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].baggaesBysector[t].baggageDescription;
            this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggagename = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].baggaesBysector[t].baggageDescription;
            this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].checksectorHititbag = true;
          }
        }
      }
    }

  }

  AddSsrSubmit() {
    this.hititloader = true;
    let bookingobjReUpdate = new BookingInfoProperties();
    bookingobjReUpdate = JSON.parse(JSON.stringify(this.bookingObj));
    if (this.bookingObj.providerCode == "EK") {
      for (let p = 0; p < this.oldbookingObj.bookingPassengerInfoProperties.length; p++) {
        if (this.oldbookingObj.bookingPassengerInfoProperties[p].passengerType == 3) {
          bookingobjReUpdate.bookingPassengerInfoProperties.push(this.oldbookingObj.bookingPassengerInfoProperties[p]);
        }
      }
    }
    if (this.typeofbooking == this.emiratesEnumsForExchangedDivide.none) {
      this.postservice.AddSsrReq(bookingobjReUpdate).subscribe((data) => {
        if (data.isSaved) {
          this.hititloader = false;
          localStorage.setItem("bookingID", this.bookingObj.bookingID.toString())

          this.router.navigateByUrl('/ticket-issuance');
        }
        else {
          this.hititloader = false;
          this.errormessageshow = data.errorInfo;
          this.errorshow = true;
        }
      });
    }
    else if (this.typeofbooking == this.emiratesEnumsForExchangedDivide.exchanged) {
      this.postservice.ExchangeAddSsrReq(bookingobjReUpdate).subscribe((data) => {
        if (data.isSaved) {
          localStorage.setItem("MessageforSeat", data.message);
          localStorage.setItem("bookingID", this.bookingObj.bookingID.toString())

          this.hititloader = false;
          this.router.navigateByUrl('/ticket-issuance');
        }
        else {
          this.hititloader = false;
          this.errormessageshow = data.errorInfo;
          this.errorshow = true;
        }
      });
    }
    else if (this.typeofbooking == this.emiratesEnumsForExchangedDivide.initial) {
      this.postservice.InitialAddSsrReq(bookingobjReUpdate).subscribe((data) => {
        if (data.isSaved) {
          this.hititloader = false;
          localStorage.setItem("bookingID", this.bookingObj.bookingID.toString())
          this.router.navigateByUrl('/ticket-issuance');
        }
        else {
          this.hititloader = false;
          this.errormessageshow = data.errorInfo;
          this.errorshow = true;
        }
      });
    }


  }
  errorclose() {
    this.errorshow = false;
  }

  processAirBlue(seat) {
    try {
      //this.bookingObj.galileoBookingProp.flightProp.flightLocationInfo[0].fromAirport
      if (this.bookingObj.galileoBookingProp.flightProp.flightLocationInfo.length == 1) {
        if (this.bookingObj.bookingPassengerInfoProperties[0].sectorInformationProperties.length == 0) {
          this.stopcount = 0;
        }
        else {
          this.stopcount = 1;
        }
      }
      else if (this.bookingObj.galileoBookingProp.flightProp.flightLocationInfo.length == 2 && this.bookingObj.galileoBookingProp.flightProp.tripType != "multi") {
        if (this.bookingObj.bookingPassengerInfoProperties[0].sectorInformationProperties.length == 2) {
          this.stopcount = 0;
        }
        else {
          this.stopcount = 1;
        }
      }
      else if (this.bookingObj.galileoBookingProp.flightProp.flightLocationInfo.length >= 2 && this.bookingObj.galileoBookingProp.flightProp.tripType == "multi") {
        if (this.bookingObj.bookingPassengerInfoProperties[0].sectorInformationProperties.length == this.bookingObj.galileoBookingProp.flightProp.flightLocationInfo.length) {
          this.stopcount = 0;
        }
        else {
          this.stopcount = 1;
        }
      }

      this.seatAirBlueList = seat;

      for (let j = 0; j < this.bookingObj.bookingPassengerInfoProperties.length; j++) {
        if (this.bookingObj.bookingPassengerInfoProperties[j].passengerType != 3) {

          //brand check condition basic or other


          for (let z = 0; z < this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.length; z++) {
            this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggagebtn = false;
            if (seat.seatbysector != null) {
              for (let y = 0; y < this.seatAirBlueList.seatbysector.length; y++) {
                if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport == this.seatAirBlueList.seatbysector[y].fromCity
                  && this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport == this.seatAirBlueList.seatbysector[y].toCity) {
                  if (this.seatAirBlueList.seatbysector[y].dynamicSeatsWithRowsExec != null) {
                    this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].seatListBysectorExec = JSON.parse(JSON.stringify(this.seatAirBlueList.seatbysector[y].dynamicSeatsWithRowsExec.rows));
                    this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].seatsectionAirplaneExec = JSON.parse(JSON.stringify(this.seatAirBlueList.seatbysector[y].dynamicSeatsWithRowsExec.seatSection));

                  }
                  if (this.seatAirBlueList.seatbysector[y].dynamicSeatsWithRowsEco != null) {
                    this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].seatListBysector = JSON.parse(JSON.stringify(this.seatAirBlueList.seatbysector[y].dynamicSeatsWithRowsEco.rows));
                  }
                  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].seatsectionAirplane = JSON.parse(JSON.stringify(this.seatAirBlueList.seatbysector[y].dynamicSeatsWithRowsEco.seatSection));
                  break;
                }
              }
            }
          }
          /*/oneway/*/
          if (this.bookingObj.galileoBookingProp.flightProp.flightLocationInfo.length == 1 && this.bookingObj.galileoBookingProp.flightProp.tripType != "multi") {
            this.processAirblueonewayBaggage(j);
          }
          else if (this.bookingObj.galileoBookingProp.flightProp.flightLocationInfo.length == 2 && this.bookingObj.galileoBookingProp.flightProp.tripType != "multi") {
            /* return flight*/
            this.processAirblueroundTripBaggage(j);
          }
          else if (this.bookingObj.galileoBookingProp.flightProp.flightLocationInfo.length >= 2 && this.bookingObj.galileoBookingProp.flightProp.tripType == "multi") {
            this.processAirbluemultiCityBaggage(j);
          }

        }
      }

    }
    catch (ee) {
      console.log(ee);
    }
    //console.log(this.bookingObj);
    this.hititloader = false;

  }
  SubmitSeatSelectionAirBlue() {
    this.hititloader = true;
    let addSeatObj = new ModifyFlightAirAiternary();
    addSeatObj.bookingInfo = this.bookingObj;
    addSeatObj.seatRequests = new Array<AirBlueMDRQ_SeatRequest>();
    for (let i = 0; i < this.bookingObj.bookingPassengerInfoProperties.length; i++) {
      if (this.bookingObj.bookingPassengerInfoProperties[i].passengerType != 3) {
        for (let z = 0; z < this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties.length; z++) {
          const xml = this.bookingObj.supplierAirPricingSolution;

          const parser = new DOMParser();
          const xmlDoc = parser.parseFromString(xml, 'text/xml');

          const flightRph =
            xmlDoc.getElementsByTagName('FlightSegment')[z]
              .getAttribute('RPH');

          const travelerRph =
            xmlDoc.getElementsByTagName('TravelerRefNumber')[i]
              .getAttribute('RPH');
          let seatreq = new AirBlueMDRQ_SeatRequest();
          let seatKey = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].seatNumber;
          // Validate seat selection
          if (!seatKey || seatKey.trim() === '') {
            this.errormessageshow = 'Please select seats for all passengers across all sectors.';
            this.errorshow = true;
            this.hititloader = false;
            return;
          }
          const match = seatKey.match(/^(\d+)([A-Za-z]+)$/);

          if (match) {
            seatreq.rowNumber = match[1]; // 4
           seatreq.seatNumber = match[2];              // "A"
          }

          seatreq.travelerRefNumberRPHList = travelerRph;
          seatreq.flightRefNumberRPHList = flightRph;
          seatreq.sectorIndex = z;
          seatreq.passengerIndex = i;
          addSeatObj.seatRequests.push(seatreq);
        }
      }
    }
    this.postservice.createBookingSeatRecord(addSeatObj).subscribe((data) => {
      if (data.isSaved) {
        this.hititloader = false;
        localStorage.setItem("bookingID", this.bookingObj.bookingID.toString());
        localStorage.setItem("isAirBlueSeatAdded", JSON.stringify(true));
        this.router.navigateByUrl('/ticket-issuance');
      }
      else {
        localStorage.setItem("isAirBlueSeatAdded", JSON.stringify(false));
        this.hititloader = false;
        this.errormessageshow = data.errorInfo;
        this.errorshow = true;
      }
    })

  }
  SubmitBaggageSelectionAirBlue() {
    this.hititloader = true;
    let addBaggageObj = new ModifyFlightAirAiternary();
    addBaggageObj.bookingInfo = this.bookingObj;
    addBaggageObj.baggageRequests = new Array<AirBlueMDAARQ_SpecialServiceRequest>();
    for (let i = 0; i < this.bookingObj.bookingPassengerInfoProperties.length; i++) {
      if (this.bookingObj.bookingPassengerInfoProperties[i].passengerType != 3) {
        for (let z = 0; z < this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties.length; z++) {
          if (this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].extraBagCheckIn != null && this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].extraBagCheckIn!= '') {
            let baggageReq = new AirBlueMDAARQ_SpecialServiceRequest();
            const xml = this.bookingObj.supplierAirPricingSolution;

            const parser = new DOMParser();
            const xmlDoc = parser.parseFromString(xml, 'text/xml');

            const flightRph =
              xmlDoc.getElementsByTagName('FlightSegment')[z]
                .getAttribute('RPH');

            const travelerRph =
              xmlDoc.getElementsByTagName('TravelerRefNumber')[i]
                .getAttribute('RPH');

            baggageReq.itemCode = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].extraBagCheckIn;
            baggageReq.travelerRefNumberRPHList = travelerRph;
            baggageReq.flightRefNumberRPHList = flightRph;
            baggageReq.sectorIndex = z;
            baggageReq.passengerIndex = i;
            addBaggageObj.baggageRequests.push(baggageReq);
          }
        }
      }
    }
    this.postservice.createBookingExtraBaggageRecord(addBaggageObj).subscribe((data) => {
      if (data.isSaved) {
        this.hititloader = false;
        localStorage.setItem("bookingID", this.bookingObj.bookingID.toString());
        this.router.navigateByUrl('/ticket-issuance');
      }
      else {
        this.hititloader = false;
        this.errormessageshow = data.errorInfo;
        this.errorshow = true;
      }
    })

  }
}
